"use strict";
(function () {
  if (!customElements.get("sticky-atc-bar")) {
    /** Distance from viewport bottom to top edge of sticky ATC (for scroll-to-top offset). */
    function syncStickyAtcBarCssVars() {
      const bar = document.querySelector(".sticky-atc-bar");
      if (!bar) {
        document.documentElement.style.removeProperty("--atc-bar-height");
        document.documentElement.style.removeProperty("--atc-bar-stack-height");
        return;
      }
      const bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
      const height = bar.offsetHeight;
      document.documentElement.style.setProperty("--atc-bar-height", `${height}px`);
      document.documentElement.style.setProperty(
        "--atc-bar-stack-height",
        `${bottom + height}px`,
      );
    }

    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.setStickyBarHeight.bind(this);
        this.parent = this.closest(".sticky-atc-bar");
        this.select = this.querySelector(".atc-product-form .select");
        this.formBtn = this.querySelector(".button-add-card");
      }

      connectedCallback() {
        // Sync initial variant id into the hidden `name="id"` input.
        const variantSelect = this.querySelector(
          ".atc-product-form select.select__select",
        );
        if (variantSelect) {
          this.currentVariant = variantSelect.value;
          const idInput = this.querySelector(
            'form[data-type="add-to-cart-form"] input[name="id"]',
          );
          if (idInput) idInput.value = this.currentVariant;
        }
        this.onVariantChange();
        this.subscribeToCartUpdate();
        this.attachResizeHandler();
        this.setStickyBarHeight(); // Need for correctly positioning scroll to top btn
        this.subscribeToVariantChange();
      }

      disconnectedCallback() {
        this.cleanup(); // Clean up listeners and observers
      }

      subscribeToVariantChange() {
        if (
          typeof subscribe === "undefined" ||
          typeof PUB_SUB_EVENTS === "undefined"
        )
          return;
        this.variantChangeUnsub = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const variant = event?.data?.variant;
            if (!variant) return;
            this.currentVariant = String(variant.id);
            const select = this.querySelector(".select__select");
            const idInput = this.querySelector(
              'form[data-type="add-to-cart-form"] input[name="id"]',
            );
            if (select) select.value = this.currentVariant;
            if (idInput) idInput.value = this.currentVariant;
            const sectionId = this.dataset.sectionId;
            const dataEl = sectionId
              ? document.getElementById(`sticky-atc-data-${sectionId}`)
              : null;
            const config = dataEl ? JSON.parse(dataEl.textContent) : null;
            this.updatePriceFromVariant(variant, config);
            this.toggleAddButton(
              !variant.available,
              window.variantStrings?.soldOut,
            );
            const atcImage = this.querySelector("img");
            const opt = select?.querySelector(
              `option[value="${this.currentVariant}"]`,
            );
            if (atcImage && opt?.dataset.media) atcImage.src = opt.dataset.media;
          },
        );
      }

      onVariantChange = () => {
        if (!this.select) return;
        this.select.addEventListener("change", (e) => {
          this.updateMasterId(e);
          this.renderProductInfo();
        });
      };

      subscribeToCartUpdate() {
        if (
          typeof subscribe === "undefined" ||
          typeof PUB_SUB_EVENTS === "undefined"
        )
          return;
        const behavior = this.parent?.dataset.behavior;
        if (behavior !== "hide-after-add") return;

        const productId = this.parent?.dataset.id;
        const sectionId = this.dataset.sectionId;
        const dataEl = sectionId
          ? document.getElementById(`sticky-atc-data-${sectionId}`)
          : null;
        let variantIds = new Set();
        try {
          const config = dataEl ? JSON.parse(dataEl.textContent) : null;
          variantIds = new Set(
            (config?.variants || []).map((v) => String(v.id)),
          );
        } catch {
          return;
        }

        this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
          if (!payload || payload.source !== "product-form") return;
          const addedId = payload.productVariantId;
          if (addedId == null || !variantIds.has(String(addedId))) return;
          if (productId) addHiddenProduct(productId);
          this.parent?.classList.remove("atc-visible");
        });
      }

      updateMasterId(e) {
        this.currentVariant = e.target.value;

        // Keep hidden Shopify variant input in sync (used when submitting to /cart/add).
        const idInput = this.querySelector(
          'form[data-type="add-to-cart-form"] input[name="id"]',
        );
        if (idInput) idInput.value = this.currentVariant;
      }

      renderProductInfo() {
        const sectionId = this.dataset.sectionId;
        const dataEl = sectionId
          ? document.getElementById(`sticky-atc-data-${sectionId}`)
          : null;
        const config = dataEl ? JSON.parse(dataEl.textContent) : null;

        let variant = config?.variants?.find(
          (v) => String(v.id) === String(this.currentVariant),
        );

        if (!variant) {
          const opt = this.querySelector(
            `.select__select option[value="${this.currentVariant}"]`,
          );
          if (opt?.dataset.priceCents) {
            const price = parseInt(opt.dataset.priceCents, 10) || 0;
            const compareAt = parseInt(opt.dataset.compareAtPrice, 10) || 0;
            variant = {
              id: this.currentVariant,
              price,
              compare_at_price: compareAt > 0 ? compareAt : null,
              available: opt.dataset.available !== "false",
            };
          }
        }

        if (variant) {
          this.updatePriceFromVariant(variant, config);
          this.toggleAddButton(
            !variant.available,
            window.variantStrings?.soldOut,
          );
          return;
        }

        // Fallback: fetch (may return wrong variant due to Shopify section rendering)
        const url = `${this.dataset.url}?variant=${this.currentVariant}`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const addButtonUpdated =
              html.querySelector(".sticky-atc-bar .button-add-card") ||
              html.querySelector(".sticky-atc-bar .product-form__submit") ||
              html.querySelector(".main-product .product-form__submit");
            this.toggleAddButton(
              addButtonUpdated?.hasAttribute("disabled") ?? false,
              window.variantStrings?.soldOut,
            );
            const priceBlock =
              html.querySelector(".sticky-atc-bar .atc-product-info .price") ||
              html.querySelector(".atc-product-info .price") ||
              html.querySelector(".product .price");
            this.updatePrice(priceBlock);
          });
      }

      formatMoney(cents, config) {
        const format = config?.currencyCodeEnabled
          ? config.moneyWithCurrencyFormat
          : config?.moneyFormat;
        if (!format || typeof cents !== "number") return String(cents / 100);
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholderRegex);
        if (!match) return String(cents / 100);
        const precision =
          match[1].includes("no_decimals") ||
          match[1].includes("amount_no_decimals")
            ? 0
            : 2;
        const thousands = match[1].includes("comma_separator") ? "." : ",";
        const decimal = match[1].includes("comma_separator") ? "," : ".";
        let number = (cents / 100).toFixed(precision);
        const parts = number.split(".");
        const dollars = parts[0].replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1" + thousands,
        );
        const centsPart = parts[1] ? decimal + parts[1] : "";
        const value = dollars + centsPart;
        return format.replace(placeholderRegex, value);
      }

      buildPriceHtml(variant, config) {
        const price = variant.price;
        const compareAtPrice =
          variant.compare_at_price > 0 ? variant.compare_at_price : null;
        const available = variant.available;
        const onSale = compareAtPrice != null && compareAtPrice > price;
        const moneyFormat = config?.currencyCodeEnabled
          ? config.moneyWithCurrencyFormat
          : config?.moneyFormat;
        const format = (c) => this.formatMoney(c, config);

        let saleBadgeHtml = "";
        if (onSale && config?.saleBadgeStyle) {
          const saleTextColor = config.saleTextColor || "secondary";
          let badgeText = config.onSale || "Sale";
          if (config.saleBadgeStyle === "saving") {
            const savingsFormatted = this.formatMoney(
              compareAtPrice - price,
              config,
            );
            badgeText = "Save " + savingsFormatted;
          } else if (config.saleBadgeStyle === "percentage") {
            const pct = Math.round(
              ((compareAtPrice - price) / compareAtPrice) * 100,
            );
            badgeText = pct + "% Off";
          }
          saleBadgeHtml = `<span class="discount-badge text-color-${saleTextColor} badge background--sale badge-top">${badgeText}</span><span class="badge-divider"> </span>`;
        }

        const regularPriceHtml = `<span class="visually-hidden visually-hidden--inline">${config?.regularPrice || "Regular price"}</span><span class="price-item price-item--regular text-weight-600">${format(price)}</span>`;
        const salePriceHtml = `<span class="visually-hidden visually-hidden--inline">${config?.salePrice || "Sale price"}</span><span class="price-item price-item--sale text-weight-600">${format(price)}</span>`;
        const comparePriceHtml = onSale
          ? `<span class="visually-hidden visually-hidden--inline">${config?.regularPrice || "Regular price"}</span><span class="price-item--last"><span class="price-item price-item--regular text-weight-400">${format(compareAtPrice)}</span></span>${saleBadgeHtml}`
          : "";

        const soldOutClass = !available ? " price--sold-out" : "";
        const onSaleClass = onSale ? " price--on-sale" : "";

        return `<div class="price${soldOutClass}${onSaleClass}"><div class="price__container"><div class="price__regular">${regularPriceHtml}</div><div class="price__sale">${salePriceHtml}${comparePriceHtml}</div><small class="unit-price caption hidden"><span class="visually-hidden">Unit price</span><span class="price-item price-item--last text-weight-600"></span></small></div></div>`;
      }

      updatePriceFromVariant(variant, config) {
        const html = this.buildPriceHtml(variant, config);
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html.trim();
        const newPrice = wrapper.firstChild;
        const oldPrice =
          this.querySelector(".atc-product-info .price") ||
          this.querySelector(".price");
        if (oldPrice && newPrice) oldPrice.replaceWith(newPrice);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = this.formBtn;
        if (!addButton) return;

        const addButtonText = addButton.querySelector("span");

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) {
            if (addButtonText) addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          if (addButtonText)
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      updatePrice(newPrice) {
        if (!newPrice) return;

        const oldPrice =
          this.querySelector(".atc-product-info .price") ||
          this.querySelector(".price");
        if (!oldPrice) return;

        oldPrice.replaceWith(newPrice);
      }

      setStickyBarHeight() {
        syncStickyAtcBarCssVars();
      }

      attachResizeHandler() {
        this.resizeObserver = new ResizeObserver(() =>
          this.setStickyBarHeight(),
        );
        this.resizeObserver.observe(this);
        window.addEventListener("resize", () => {
          this.setStickyBarHeight.call(this);
        });
      }

      cleanup() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect(); // Stop observing size changes
        }
        if (this.variantChangeUnsub) {
          this.variantChangeUnsub();
        }
        if (this.cartUpdateUnsub) {
          this.cartUpdateUnsub();
        }
      }
    }

    customElements.define("sticky-atc-bar", StickyAtcBar);

    // Utility functions for sessionStorage
    function getHiddenProducts() {
      try {
        const hidden = sessionStorage.getItem("sticky-atc-hidden-products");
        return hidden ? JSON.parse(hidden) : [];
      } catch (e) {
        return [];
      }
    }

    function setHiddenProducts(products) {
      try {
        sessionStorage.setItem(
          "sticky-atc-hidden-products",
          JSON.stringify(products),
        );
      } catch (e) {
        console.warn("Could not save to sessionStorage:", e);
      }
    }

    function addHiddenProduct(productId) {
      const hidden = getHiddenProducts();
      if (!hidden.includes(productId)) {
        hidden.push(productId);
        setHiddenProducts(hidden);
      }
    }

    function isProductHidden(productId) {
      const hidden = getHiddenProducts();
      return hidden.includes(productId);
    }

    function checkBarVisibility() {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      const productVisible = document.querySelector(
        ".product .product__info-wrapper",
      );
      const closeBtn = document.querySelector(".atc-product-form-close");

      if (!stickyAtcBar || !productVisible || !closeBtn) return;

      const productId = stickyAtcBar.dataset.id;
      const behavior = stickyAtcBar.dataset.behavior;

      // Check if product should be hidden based on sessionStorage
      if (
        (behavior === "hide" || behavior === "hide-after-add") &&
        isProductHidden(productId)
      ) {
        return; // Don't show the bar at all
      }

      document.addEventListener("scroll", (e) => {
        // Skip if product is hidden
        if (
          (behavior === "hide" || behavior === "hide-after-add") &&
          isProductHidden(productId)
        ) {
          return;
        }

        let productVisibleHeight = productVisible.offsetHeight / 2;
        let scrolled = document.scrollingElement.scrollTop;

        if (
          scrolled > productVisibleHeight &&
          !stickyAtcBar.classList.contains("js-hidden")
        ) {
          stickyAtcBar.classList.add("atc-visible");
        } else {
          stickyAtcBar.classList.remove("atc-visible");
        }
      });

      closeBtn.addEventListener("click", () => {
        // Hide bar for current page session
        stickyAtcBar.classList.remove("atc-visible");
        stickyAtcBar.classList.add("js-hidden");

        // If behavior is 'hide', also persist hiding across page views
        if (behavior === "hide" && productId) {
          addHiddenProduct(productId);
        }
      });
    }

    document.addEventListener("DOMContentLoaded", checkBarVisibility);
    document.addEventListener("shopify:section:load", checkBarVisibility);

    function addStickySpace() {
      const checkMobileStickyBar = document.querySelector(
        ".mobile-sticky-bar ",
      );
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");

      if (!stickyAtcBar) {
        syncStickyAtcBarCssVars();
        return;
      }

      const productId = stickyAtcBar.dataset.id;
      const behavior = stickyAtcBar.dataset.behavior;

      // Skip if product is hidden
      if (
        (behavior === "hide" || behavior === "hide-after-add") &&
        isProductHidden(productId)
      ) {
        return;
      }

      const style = stickyAtcBar.dataset.style;
      const bottom =
        style == "default" ||
        (style == "default-swatches") | (window.innerWidth < 750)
          ? 0
          : 15;

      if (
        window.innerWidth < 750 &&
        checkMobileStickyBar &&
        checkMobileStickyBar.classList.contains("active")
      ) {
        const mobileStickyBarHeight = checkMobileStickyBar.offsetHeight;
        stickyAtcBar.style.bottom = `${mobileStickyBarHeight + bottom}px`;
      } else {
        stickyAtcBar.style.bottom = `${bottom}px`;
      }

      syncStickyAtcBarCssVars();
    }

    document.addEventListener("DOMContentLoaded", addStickySpace);
    document.addEventListener("shopify:section:load", addStickySpace);
    window.addEventListener("resize", addStickySpace);
    window.addEventListener("scroll", addStickySpace);

    // Do not override sticky-bar price HTML here.
    // The sticky element itself re-renders the full `.price` block via `renderProductInfo()`.
    const stickyAtcSelect = document.querySelector("sticky-atc-bar .select__select");
    const atcImage = document.querySelector("sticky-atc-bar img");
    if (stickyAtcSelect && atcImage) {
      stickyAtcSelect.onchange = function () {
        const getNewImage = stickyAtcSelect.options[this.selectedIndex].getAttribute("data-media");
        if (getNewImage != null) atcImage.src = getNewImage;
      };
    }
  }

  if (!customElements.get("sticky-atc-variants")) {
    class StickyAtcVariants extends HTMLElement {
      constructor() {
        super();
        this.handleSwatchClick = this.handleSwatchClick.bind(this);
        this.handleSwatchKeydown = this.handleSwatchKeydown.bind(this);
        this.addActiveState = this.addActiveState.bind(this);
        this.checkCurrentVariant = this.checkCurrentVariant.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      init() {
        this.productCard = this.closest("sticky-atc-bar");
        if (!this.productCard) return;

        this.url = this.productCard.dataset.url || "";
        this.select = this.productCard.querySelector(".select__select");
        this.cardColorSwatches = [...this.querySelectorAll(".card-variant")];
        if (!this.cardColorSwatches.length || !this.select) return;

        this.currentId =
          this.select.value || this.cardColorSwatches[0]?.dataset.variantId;

        this.cardColorSwatches.forEach((swatch) => {
          swatch.addEventListener("click", this.handleSwatchClick);
          swatch.addEventListener("keydown", this.handleSwatchKeydown);
        });

        // Set the active state initially
        this.addActiveState();
      }

      handleSwatchClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const swatch = event.currentTarget;
        this.updateActiveSwatch(swatch);
      }

      handleSwatchKeydown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          const swatch = event.currentTarget;
          this.updateActiveSwatch(swatch);
        }
      }

      updateActiveSwatch(swatch) {
        const { variantId } = swatch.dataset;
        if (!variantId || this.checkCurrentVariant(variantId)) return;

        const matchingOption = Array.from(this.select.options).find(
          (option) => option.value === variantId,
        );

        if (matchingOption) {
          this.select.value = variantId;
          this.select.dispatchEvent(new Event("change", { bubbles: true }));
        }

        this.addActiveState();
      }

      addActiveState() {
        let foundActive = false;

        this.cardColorSwatches.forEach((swatch) => {
          const { variantId } = swatch.dataset;

          if (variantId === this.select.value && !foundActive) {
            swatch.classList.add("active");
            foundActive = true; // Ensure only one swatch is active
          } else {
            swatch.classList.remove("active");
          }
        });
      }

      checkCurrentVariant(id) {
        if (this.currentId === id) {
          return true;
        }
        this.currentId = id;
        return false;
      }

      cleanup() {
        // Remove all event listeners
        this.cardColorSwatches.forEach((swatch) => {
          swatch.removeEventListener("click", this.handleSwatchClick);
          swatch.removeEventListener("keydown", this.handleSwatchKeydown);
        });
      }
    }

    customElements.define("sticky-atc-variants", StickyAtcVariants);
  }

  const stickyAtcBtn = document.querySelector(".sticky-atc-bar__close");

  if (stickyAtcBtn) {
    const addOnClickHandler = () => {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      if (!stickyAtcBar) return;

      stickyAtcBtn.addEventListener("click", () => {
        stickyAtcBar.classList.add("js-hidden");
        stickyAtcBar.classList.remove("atc-visible");
      });
    };

    addOnClickHandler();
  }
})();
